import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { FormControlLabel as MuiFormControlLabel } from '@material-ui/core';
import { spacing } from '@material-ui/system';
export var FormControlLabel = styled(MuiFormControlLabel)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), spacing);